export enum PlatformAccessState {
  Active = 'active', // user can access to the platform
  Inactive = 'inactive', // user can't access to the platform
  Disabled = 'disabled', // user can't access, probably too many login attempts failed
}
